<template>
  <div>
    <NoteEditor v-if="isEdit" :noteData="noteData" :index="index"></NoteEditor>
    <div :class="['note', noteData.IsTopNote ? 'topNote': '' ]" v-else style="background-color: rgba(0,0,0,0.05); border-radius: 10px;">
      <div style="text-align: right; padding: 10px;">
        <span><b>{{noteData.Time}} {{noteData.UserFullName}}</b></span><span> ({{noteData.UserType}})</span>
      </div>
      <div v-html="noteInfo" style="text-align: right; padding: 10px;"></div>
      <div class="filesList" v-if="noteData.Attachments">
        <div style="color: brown;">קבצים מצורפים:</div>
        <div v-for="file in noteData.Attachments">
          <audio class="audioChat" controls v-if="file.Type == 'Record'">
            <source :src="file.FileUrl" type="audio/mp3">
          </audio>
          <a v-else target="_blank" :href="file.FileUrl" style="color: blue; text-decoration: underline;display: block;">{{file.FileName}}</a>
        </div>
      </div>
      <div class="noteCtrls" v-if="canEdit">
        <v-icon @click="edit(noteData)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'עריכה' }">border_color</v-icon>
        <v-icon @click="confirm(noteData['.key'])" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>
      </div>
    </div>
    
  </div>
</template>
<script>
  import { db, storage } from '../firebase';
  var pagesRef = db.ref('Pages');
  import NoteEditor from '../components/NoteEditor';

  export default {
    name: 'Note',
    components: { NoteEditor },
    props: ['noteData', 'index', 'canEdit'],
    data() {
      return {
        isShow: false,
        isEdit: false,
        selectedNoteKey: '',
        page: '',
      }
    },
    created() {
      this.$Log("Vue [Note] is created ...");
    },
    ready() {
      this.$Log("Vue [Note] is ready ...");
    },
    mounted() {
      this.$Log("Vue [Note] is mounted ...");
    },
    updated() {
      this.$Log("Vue [Note] is updated ...");
    },
    computed: {
      //isEdit() {
      //  if (this.noteData['.key'] == this.selectedNoteKey) {
      //    return this.$root.isEditNote;
      //  }
      //  else {
      //    return false;
      //  }
      //},
      txtId() {
        return 'txt' + this.index;
      },
      noteInfo() {
        var splittedNote = this.noteData.Info.split("\n");
        var noteText = '';
        for (var l = 0; l < splittedNote.length; l++) {
          noteText += splittedNote[l] + "<br/>";
        }
        return noteText;
        //var noteText = this.currentNote.Info.replace("\n", "<br/>");
        var noteText = this.noteData.Info.replace("\n", "<br/>");
        console.log(noteText)
        return noteText;
      },
      hasRecord() {
        return (this.noteData.Record && this.noteData.Record.length > 0);
      }
    },
    watch: {
      '$root.confirm.isConfirmed'(val) {
        if (val && this.$root.confirm.caller == 'RemoveNote') {
          this.remove();
        }
      }
    },
    methods: {
      edit(noteData) {
        //this.selectedNoteKey = noteData['.key']
        //this.$root.isEditNote = true;
        this.isEdit = true;
      },
      confirm(key) {
        console.log("confirm >> " + key)
        this.$root.confirm = {
          isVisible: true,
          title: 'מחיקה',
          question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
          caller: 'RemoveNote',
          isConfirmed: false
        }

        this.selectedNoteKey = key;

        //this.noteData.UserKey
      },
      remove() {
        if (this.noteData['.key'] == this.selectedNoteKey) {
          console.log("Remove note >> " + this.selectedNoteKey);
          var notePath = "DiaryPages/" + this.$root.activeDiaryPage.PageKey + "/Notes/" + this.selectedNoteKey;
          var noteRef = db.ref(notePath);
          noteRef.remove();
          this.selectedNoteKey = '';
          this.$parent.loadPage();
        }
      }
    }
  }

</script>
<style>
  .note {
    text-align: right;
    /*margin-top: 60px;*/
    margin-top: 30px;
    line-height: 28px;
    font-size: 18px;
    /*border-bottom: 1px dotted rgba(0,0,0,0.1)*/
    /*background-color: rgba(0,0,0,0.05);*/
    border: 1px solid rgba(0,0,0,0.1);
    border-radius: 10px;
    margin: 10px;
    margin-bottom: 30px;
  }
    /*.note:hover .noteCtrls {
      display: block;
    }*/

    .topNote {
      background-color: rgba(255,0,0,0.1) !important;
    }
  /*.note:hover {
      border: 1px solid #F7941D;
    }*/
  .time {
    background-color: red;
  }

  .txtNote {
    width: 100%;
    height: 120px;
    border: none;
    line-height: 32px;
    padding: 0px;
    margin: 0px;
    background-color: rgba(255,255,0,0.1);
  }
  .filesList {
    padding: 0px;
    margin: 0px;
    /*background-color: rgba(0,0,0,0.05);*/
  }

    .filesList > a {
      text-decoration: underline;
      cursor: pointer;
      max-width: 300px;
      overflow-x: hidden;
      width: 250px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

  .lnkUpload {
    text-decoration: underline;
    cursor: pointer;
  }

  .noteCtrls {
    /*float: left;*/
    background-color: rgba(0,0,0,0.05);
    border-radius: 0px 0px 10px 10px;
    text-align: left;
    /*border-top: none;*/
    /*border-left: 1px solid rgba(0,0,0,0.05);
    border-right: 1px solid #ccc;*/
    /*border-bottom: 1px solid #ccc;*/
    /*display: none;*/
  }

</style>



// WEBPACK FOOTER //
// Note.vue?c02674c2